console.log('tracking script loaded');

const url = window.location.href;
const queryString = window.location.search;

function processURLquery(key) {

    console.log(queryString)
    const urlParams = new URLSearchParams(queryString)
    return urlParams.get(key)
}


function setLocalStorageWithUTMvalues() {

    const UTMsource = processURLquery('utm_source')
    const UTMmedium = processURLquery('utm_medium')
    const UTMcampaign = processURLquery('utm_campaign')
    const UTMcontent = processURLquery('utm_content')

    
    _storagePlacer(UTMsource,'utm_source')
    _storagePlacer(UTMmedium,'utm_medium')
    _storagePlacer(UTMcampaign, 'utm_campaign')
    _storagePlacer(UTMcontent,'utm_content')

    console.log("utm_source", UTMsource, "query string", queryString.length)

    function _storagePlacer(value,key){

        let storageItem = localStorage.getItem(key)

        if (value !== null) {

            if (value !== storageItem) {
                
                localStorage.setItem(key, value)
            }
        } 

        //Is this a new campaign with a new UTM Source - we don't want to cross pollute so change storage item to null
        if (value === null && UTMsource) {

            localStorage.removeItem(key)
        }    
}
}


//If there's a local storage session set and no UTM value already then...
function decorateLinkWithUTMfromStorage() {

    let localStorageUTMSource = localStorage.getItem("utm_source")
    let localStorageUTMMedium = localStorage.getItem("utm_medium")
    let localStorageUTMCampaign = localStorage.getItem("utm_campaign")
    let localStorageUTMContent = localStorage.getItem("utm_content")
    let localStorageA2employerName = localStorage.getItem("a2") ? `&a2=${localStorage.getItem("a2")}` : ''
    let decoratedQuery = `utm_source=${localStorageUTMSource}&utm_medium=${localStorageUTMMedium}&utm_campaign=${localStorageUTMCampaign}&utm_content=${localStorageUTMContent}${localStorageA2employerName}`
    console.log(decoratedQuery,"queryString")


    const utmLinks = document.querySelectorAll('.js-campaign-utm-decorator a, .js-campaign-link-utm a') //this is added via advanced field in WP CMS so make sure that the child 'a' is also targeted.

    for (const utmLink of utmLinks) { 

        const existingQueryStr = utmLink.search //if there is already a query string we want to preserve it.

        if (existingQueryStr) {
            utmLink.href = `${utmLink.href}&${decoratedQuery}` //append the decorated query
        } else {
            utmLink.href = `${utmLink.href}?${decoratedQuery}`
        }
    }
    
}

document.addEventListener("DOMContentLoaded", function () {

    setLocalStorageWithUTMvalues()
    decorateLinkWithUTMfromStorage()
    
})